class AlAnfarShopNavigation extends HTMLElement {
  connectedCallback() {
    this.campaign = this.querySelector('[data-shop-nav-campaign]');
    this.image = this.querySelector('[data-shop-nav-image]');
    this.kicker = this.querySelector('[data-shop-nav-kicker]');
    this.campaignTitle = this.querySelector('[data-shop-nav-title]');
    this.links = [...this.querySelectorAll('[data-shop-nav-family]')];

    this.links.forEach((link) => {
      link.addEventListener('pointerenter', () => this.preview(link));
      link.addEventListener('focus', () => this.preview(link));
    });
  }

  preview(link) {
    if (!link || !this.campaign || !this.image) return;

    this.links.forEach((item) => item.classList.toggle('is-active', item === link));
    this.image.src = link.dataset.image || this.image.src;
    this.campaign.href = link.href;
    if (this.kicker) this.kicker.textContent = link.dataset.kicker || '';
    if (this.campaignTitle) this.campaignTitle.textContent = link.dataset.title || '';
  }
}

if (!customElements.get('al-anfar-shop-navigation')) {
  customElements.define('al-anfar-shop-navigation', AlAnfarShopNavigation);
}
